import React, { forwardRef } from 'react';
import { useGetProductImageQuery } from 'store/services/segmentsApi';
import { useParseURLQueryParams } from 'utils';

type ProductImageProps = {
  productId: number;
  alt?: string;
  fallback_url?: string;
} & React.ComponentPropsWithoutRef<'img'>;

export const ProductImage = forwardRef(
  (
    {
      productId,
      alt,
      fallback_url = '/assets/image-placeholder.png',
      ...props
    }: ProductImageProps,
    ref: React.Ref<HTMLImageElement>
  ) => {
    const { serializedStoreName } = useParseURLQueryParams();

    const { data } = useGetProductImageQuery(
      {
        serializedStoreName: String(serializedStoreName),
        product_id: String(productId),
      },
      {
        skip: !serializedStoreName || !productId,
      }
    );

    const handleOnError = (e: any) => {
      e.target.onerror = null;
      e.target.src = fallback_url;
    };

    const imageUrl = data
      ? data.length > 0
        ? data[0].image_url || fallback_url
        : fallback_url
      : fallback_url;

    const productTitle = data
      ? data.length > 0
        ? data[0].title || ''
        : ''
      : '';

    return (
      <img
        ref={ref}
        src={imageUrl}
        onError={handleOnError}
        alt={alt ?? productTitle}
        {...props}
      />
    );
  }
);
